import { ProductEvent } from "@classdojo/log-client/lib/client/client";

// client hook into android (uses img instead of iframe because of limitations in android)
function executeCommand(url: string, queryParams: Record<string, string | number | boolean> = {}) {
  const img: HTMLElement = document.createElement("IMG");

  img.setAttribute("style", "display: none");

  queryParams._cacheDefeat = new Date().getTime();
  const queryString = Object.entries(queryParams)
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");
  img.setAttribute("src", `${url}?${queryString}`);

  document.body.appendChild(img);
  img.parentNode?.removeChild(img);
}

export function init() {
  executeCommand("https://toolkit.classdojo.com/command/init");
}

export const showNativeNav = (shouldShow: boolean) => {
  executeCommand("https://toolkit.classdojo.com/command/showBottomBar", { shouldShow });
};

export const closeWebview = () => {
  executeCommand("https://toolkit.classdojo.com/command/closeWebview");
};

export function openSalesPage() {
  executeCommand("https://toolkit.classdojo.com/command/openSalesPage");
}

export function openPointsSheet() {
  executeCommand("https://toolkit.classdojo.com/command/openPointsSheet");
}

export const logEvent = (event: ProductEvent) => {
  executeCommand("https://toolkit.classdojo.com/command/logEvent", { name: event.eventName });
};
